import type { TreeTag } from '#domains/tags';

export const filterDuplicates = (tags: TreeTag[]) => {
  return [...new Map(tags.map(tag => [tag.id, tag])).values()];
};
